import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    children?: any;
    isTransparent?: boolean;
    onClick?: (e: MouseEvent) => void;
}

export class Overlay extends React.Component<IProperties>
{
    public static defaultProps: Partial<IProperties> = {
        isTransparent: false
    };

    private onClick(e: MouseEvent): void
    {
        if (this.props.onClick != null)
            this.props.onClick(e);
    }

    render()
    {
        var className: string;
        if (this.props.isTransparent)
            className = "ui-overlay ui-overlay--transparent";
        else
            className = "ui-overlay";

        return (
            <div
                className={className}
                onClick={this.onClick.bind(this)}>
                {this.props.children}
            </div>
        );
    }
}